/**
 * Clones the <template id="..."> with the given id and returns its root element.
 * Throws if the template is not found.
 */
export function renderTemplate(id) {
    let template = document.getElementById(id);
    if (!template) {
        throw new Error(`Template not found: #${id}`);
    }
    return template.content.cloneNode(true).firstElementChild;
}

/**
 * Replaces the contents of #view-container with the given element.
 */
export function replaceViewContainer(el) {
    replaceContent(document.getElementById('view-container'), el);
}

/**
 * Empties a container element and appends el as its sole child.
 */
export function replaceContent(container, el) {
    container.innerHTML = '';
    container.appendChild(el);
}

/**
 * Displays an error message in the #error element and locks all controls.
 */
export function showError(err) {
    console.error(err);
    let errorEl = document.getElementById('error');
    if (errorEl) {
        let message =
            err instanceof Response
                ? `Anfrage fehlgeschlagen: ${err.status} ${err.statusText}`
                : err && err.message
                  ? err.message
                  : String(err);
        errorEl.textContent = message;
        errorEl.hidden = false;
    }
    lockControls();
}

/**
 * Disables all form controls that are not marked with data-exempt.
 */
export function lockControls() {
    document
        .querySelectorAll('input, button, select, textarea')
        .forEach((el) => {
            if (!el.dataset.exempt) {
                el.disabled = true;
            }
        });
}

export function getParentAttr(el, name) {
    while (el) {
        let val = el.getAttribute(name);
        if (val !== undefined && val !== null) {
            return val;
        }
        el = el.parentElement;
    }
    return null;
}
